import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { API, useDevices } from '@unboared/react';
import { QRCodeSVG } from 'qrcode.react';
import { JoinButton } from '~/components/design/buttons/JoinButton';

import styles from './QRCodeView2.module.css';
import { AnimatedAvatar } from './AnimatedAvatar';

export default function QRCodeView2() {
    const { t } = useTranslation();
    const { gamepadIDs } = useDevices();
    const ref = useRef<HTMLDivElement>(null);

    return (
        <div className={styles.container}>
            <div className={styles.left}>
                <div className={styles.joinButton}>
                    <JoinButton>{t('console.join')}</JoinButton>
                </div>
                <div className={styles.qrCard}>
                    <QRCodeSVG className={styles.qrcode} value={API.getSessionLink()} />
                </div>
            </div>
            {gamepadIDs.length > 0 && (
                <div className={styles.right}>
                    <div className={styles.rightHeader}>
                        <span className={styles.countBadge}>{gamepadIDs.length}</span>
                        {/* mot « joueurs » localisé (5 langues), réutilisé tel quel */}
                        <span>{t('gamepad.freePlay.players')}</span>
                    </div>
                    <div ref={ref} className={styles.unguys}>
                        {gamepadIDs.map((gamepadID) => (
                            <AnimatedAvatar key={gamepadID} gamepadID={gamepadID} containerRef={ref} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
